<template>
<div>
  <div class="col">
    <div class="col-claim map-row">
      <div class="wrap map" v-if="!gameEnd">
        <div class="game-map">
          <div class="item one" :class="orderOne">
            <i  class="icon"></i>
          </div>
          <div class="item two" :class="orderTwo">
            <i ref="order2pulse" class="icon"></i>
          </div>
          <div class="item tree" :class="orderTree">
            <i  ref="order3pulse" class="icon"></i>
          </div>
        </div>
        <div class="status-bar hide-mob">
          <div class="step-bar">
            <div class="game-step">
              <div ref="barstat" class="game-step_bar"></div>
            </div>
          </div>
        </div>
        <div class="game-title">
          <div class="item">
            <h2>
              <span>Misja</span>
              pieniądze od podszewki
              <span class="white">bankosłówka</span>
            </h2>
          </div>
          <div class="item">
            <h2>
              <span>Misja</span>
              Bezpieczeństwo
              <span class="white">piny bez spiny</span>
            </h2>
          </div>
          <div class="item">
            <h2>
              <span>Misja</span>
              Zarządzam budżetem
              <span class="white">Wirtualny sklepik</span>
            </h2>
          </div>
        </div>
      </div>
      <div class="wrap last_order" v-if="gameEnd">
        <div class="last_order_item"></div>
        <div class="wrap_benia_last">
          <div class="benia">
            <div class="message-box">
              <div class="top"></div>
              <div class="wrap left">
                <h3 class="headline hide-mob">Gratulacje!</h3>
                <p ref="quote">
                  Zaliczyłeś 3 misje. W nagrodę
                  otrzymujesz  <span class="text-blue">Certyfikat Samodzielniaka</span>.
                  Kliknij POBIERZ, żeby wydrukować.
                </p>
              </div>
              <div class="bottom"></div>
            </div>
          </div>
          <button class="btn btn-green btn-cert" @click="getCert(setupGame.playerName)"><span>Pobierz</span></button>
        </div>
        <div class="ducks duck150 bird">
          <div  ref="message" class="message-box left">
            <div class="top"></div>
            <div class="wrap">
              <p>Już wkrótce kolejne<br /> nowe Misje!</p>
            </div>
            <div class="bottom"></div>
          </div>
        </div>
      </div>
      <button ref="startGameBtn" class="btn btn-green" :class="{hide : orderTree === 'done'  }" @click="setNextGame()"><span>START</span></button>
    </div>
  </div>
</div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import { TimelineLite } from 'gsap'
import axios from 'axios';
import { saveAs } from 'file-saver'

export default {
name: "OrganismGameMap.vue",
  data () {
    return {
      stepsGame: null,
      statusBar: 0 ,
      active: false,
      locked: false,
      orderOne:false,
      orderTwo:false,
      orderTree:false,
      gameEnd:false,
      gamenameGTM:'',
    }
  },
  props:{
    stepOrder:{
      type: String,
    },
  },
  methods:{
    ...mapActions(['audioPlayer','stopAudio']),
    ...mapMutations(['SET_ACTIVE_GAME','SET_GAME_LVL','SET_ACTIVE_VIEW','SET_GAME_RULES']),
    setNextGame(){
          let setGame =  this.stepsGame + 1;
          this.SET_ACTIVE_GAME(setGame);
          this.SET_ACTIVE_VIEW(1);
          this.SET_GAME_LVL(null);
          this.SET_GAME_RULES(false);

            if (this.setupGame.gameType == 1){
              this.gamenameGTM = "Pieniądze od podszewki"
            }else if(this.setupGame.gameType == 2){
              this.gamenameGTM = "Misja bezpieczeństwo"
            }else if(this.setupGame.gameType == 3){
              this.gamenameGTM = "Zarządzam budżetem"
            }


          this.$gtm.push({
            event: 'ms-gameevent',
            category: "Misja samodzielność",
            action: "Kliknięcie w button - PRZEJDŹ DALEJ",
            label: "Wybór kolejnej gry: "+this.gamenameGTM+"",  //  gameType
          })

    },
    getCert(paylod){


      const sq = btoa(`${paylod.toUpperCase()}${paylod.toLowerCase()}`)
          .replace(/[^a-z']/g, '')
          .toUpperCase();

        const formData =
          {
            "name": paylod,
              "sig": sq
          }
      axios.post('https://hrcn7io5w3.execute-api.eu-central-1.amazonaws.com/production/pdf', formData, {
        responseType: 'arraybuffer',
        headers: {
          Accept: 'application/pdf',
          'Content-Type': 'application/json',
        },
      })
          .then((resp) => {
            const blob = new Blob([resp.data], {
              type: 'application/pdf',
            })
            saveAs(blob, 'certyfikat.pdf')
            setIsRendering(false)
          })
          .catch((err) => {
            setIsRendering(false)
          })
      this.$gtm.push({
        event: 'ms-gameevent',
        category: "Misja samodzielność",
        action: "Kliknięcie w button - POBIERZ",
        label:"Generowanie certyfikatu",  //  gameType
      })

    },



  },
  computed: {
    ...mapGetters(['setupGame']),
  },
  watch:{
    orderTree(){
      if(this.orderTree === 'done'){
        setTimeout(function(scope) {
          scope.gameEnd = true;
        }, 2500, this);
      }
    },
    orderTwo(){
      if(this.orderTwo === 'done'){
        if (window.innerWidth > 800) {
          const timeline = new TimelineLite()
          const {startGameBtn} = this.$refs
          timeline
              .to(startGameBtn, {x: 380})
        }
      }
    },
    gameEnd(){
        this.orderOne = false
        this.orderTwo = false

          this.audioPlayer({
            'url': [
              '/shop/ogolne/end_game1.mp3',
              '/shop/ogolne/kaczka_end_1.mp3',
              '/shop/ogolne/kaczka_end_2.mp3',
            ],
          })
        const timeline = new TimelineLite()
        timeline
        this.$confetti.start({
          particles: [
            {
              type: 'rect',
            }   ],
          defaultColors: [
            '#00eeac',
            '#fd032e',
            '#fdab00',
            '#03b9cd',
            '#00ee00',
            '#5900cd',
            '#bcee00',
            '#fd7f00',
            '#fd044c',
            '#fde400',
            '#fde400',
            '#fde400',
          ],
        });
      setTimeout(function(scope) {
        scope.$confetti.stop();
      }, 3000, this);
    }
  },
  mounted() {

      if (this.stepOrder === 'game_one'){
        this.orderOne = 'done';
        this.orderTwo = 'active';
        this.orderTree = 'locked';
        const timeline = new TimelineLite()
        const { order1pulse, order2pulse, barstat } = this.$refs
        timeline
            .to(order2pulse,  { scale: 1.1, yoyo: true,  repeat: -1 })
            .to(barstat,  { width:"5%" })

      }else if(this.stepOrder == 'game_two'){
        this.orderOne = 'done';
        this.orderTwo = 'done';
        this.orderTree = 'active';
        const timeline = new TimelineLite()
        const { order3pulse, barstat } = this.$refs
        timeline
            .to(order3pulse,  { scale: 1.1, yoyo: true,  repeat: -1 })
            .to(barstat,  { width:"49.5%" })

      }else if(this.stepOrder == 'game_tree'){
        this.orderOne = 'done';
        this.orderTwo = 'done';
        this.orderTree = 'done';
        const timeline = new TimelineLite()
        const { barstat } = this.$refs
        timeline
            .to(barstat,  { width:"99.5%" })
      }

    this.$confetti.stop();
      if(this.setupGame.gameType == 1){
        this.statusBar = 4;
      }else if(this.setupGame.gameType == 2){
        this.statusBar = 97;
      }
    this.stepsGame = this.setupGame.gameType;
  }
}
</script>
